import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, withLatestFrom, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as oficinasActions from '../actions/oficinas.actions';
import * as accesosActions from '../actions/accesos.actions';
import { AuthService } from '@core/security/services/auth.service';
import { select, Store } from '@ngrx/store';
import { AppState } from '@core/store';
import { currentOffices } from '../selectors/oficinas.selectors';
import { currentUser } from '../selectors/auth.selectors';

@Injectable()
export class OficinasEffects {
	constructor(private readonly actions$: Actions, private readonly store: Store<AppState>, private readonly auth: AuthService) {}

	cargarOficinas$ = createEffect(() =>
		this.actions$.pipe(
			ofType(oficinasActions.cargarOficinas),
			withLatestFrom(this.store.pipe(select(currentUser))),
			mergeMap(([action, user]) => {
				return this.auth.findAllSciOficinaByIdUsuario(user?.id ?? -1).pipe(
					map((usuarioOficinaPerfil) =>
						oficinasActions.cargarOficinasSuccess({
							sciUsuarioOficinaPerfil: usuarioOficinaPerfil,
						})
					),
					catchError((err) =>
						of(
							oficinasActions.cargarOficinasError({
								payload: err,
							})
						)
					)
				);
			})
		)
	);

	cargarOficinasSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(oficinasActions.cargarOficinasSuccess),
				withLatestFrom(this.store.pipe(select(currentOffices))),
				tap(([action, offices]) => {
					this.store.dispatch(
						oficinasActions.cambiarOficinaSeleccionada({
							sciOficina: offices.find((off) => off.ctrlOficinaPrincipal).sciOficina,
						})
					);
				})
			),
		{ dispatch: false }
	);

	cambiarOficinaSeleccionada$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(oficinasActions.cambiarOficinaSeleccionada),
				tap((action) => this.store.dispatch(accesosActions.cargarAccesos()))
			),
		{ dispatch: false }
	);
}
